import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import * as crypto from 'crypto-js';

import { urlConfig } from '../../../config/urlConfig';
import {
  accessTokenRequest,
  sendRequest,
} from '../../../services/global/global.service';
import { MeetingDetailsContext } from '../../../services/meeting-details/meeting-details.context';

const useStyles = makeStyles((theme) => ({
  submitBox: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: '24px 16px 24px 0',
    position: 'relative',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export const JoinZoomComponent = ({ user, id, status, meeting }) => {
  const classes = useStyles();
  const { functions } = useContext(MeetingDetailsContext);
  const { meetingLink } = functions;

  const [link, setLink] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showErr, setShowErr] = useState(false);

  useEffect(() => {
    user && joinMeetingLink(id, user);
  }, [id, user]);

  const encrypt = (object) => {
    return crypto.AES.encrypt(object, 'refresh_token@miz123').toString();
  };

  const joinMeetingLink = (id, user) => {
    const { username } = user;

    let convertLink = meetingLink(meeting.url);

    if (meeting) {
      if (meeting.url) {
        setLink(convertLink);
        setError(null);
      } else {
        setIsLoading(true);

        accessTokenRequest()
          .then((response) => {
            sendRequest(`${urlConfig.join_zoom}/${id}`, response, 'get', null)
              .then((res) => {
                setIsLoading(false);
                if (res.data.signaturess) {
                  setLink(
                    `${urlConfig.ZOOM_BASE_URL}/${id}/${username}/${encrypt(
                      JSON.stringify(res.data)
                    )}`
                  );
                } else {
                  setError('The meeting has not started yet');
                }
              })
              .catch((e) => {
                e.response && e.response.data && setError(e.response.data);
                setIsLoading(false);
              });
          })
          .catch((e) => {
            setError(e.toString());
            setIsLoading(false);
          });
      }
    }
  };

  const Component = () => {
    if (status === 0 || status === 1) {
      return (
        <div className={classes.submitBox}>
          <div className={classes.wrapper}>
            <Button
              variant='contained'
              color='primary'
              size='small'
              onClick={() => {
                error ? setShowErr(true) : link && window.open(link, '_self');
              }}
              disabled={isLoading}
            >
              Join Meeting
            </Button>
            {isLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}

            {error && showErr && (
              <Typography color='error'>
                {error.message ? error.message : error}
              </Typography>
            )}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return <Component />;
};
